/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M5.839 23.6492c.486.4677 1.2726.4677 1.7572 0l10.2759-9.9159c.9706-.9365.9706-2.456 0-3.3925L7.5217.3511C7.0407-.1118 6.264-.118 5.7769.3388c-.497.4665-.5033 1.2355-.0137 1.7092l9.4731 9.1406c.4859.4689.4859 1.228 0 1.6969l-9.3973 9.068c-.4859.4677-.4859 1.228 0 1.6957Z"
    clipRule="evenodd"
  />,
  'MenuExpand'
);
